module.exports = __webpack_public_path__ + "img/省级地质灾害应急值班管理系统.6fb07bf0.jpg";